import once from "lodash-es/once";
import type { Language } from "./types";

export default once((): Language => document.querySelector("html").getAttribute("lang") as Language);
